import {
  AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT,
  matchDecisionByExperiment,
} from 'constants/monetateExperiments';
import {
  getExperimentValueById,
  getOnboardingExperiencePayload,
} from 'redux/modules/experiments/selectors';
import fetchExperienceFragment from 'redux/fetchers/experience-fragment';
import { Fetcher } from 'route-data/fetcher-types';

// Matches safe, slash-separated AEM path segments, e.g. "homepage/onboarding/experiment-b".
// No leading/trailing/double slashes and no segment can be ".." as "." isn't an allowed character.
const experienceFragmentPathPattern = /^[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*$/;

interface OnboardingExperiencePayload {
  xfPath?: unknown;
}

export const getOnboardingExperienceFragmentKey = (
  variant?: string,
  payload?: OnboardingExperiencePayload,
) => {
  if (!variant || variant === AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.variant.default) {
    return undefined;
  }

  const { xfPath } = payload ?? {};

  return typeof xfPath === 'string' && experienceFragmentPathPattern.test(xfPath)
    ? xfPath
    : undefined;
};

const onboardingExperienceFragmentFetcher: Fetcher = args => (dispatch, getState) => {
  const state = getState();
  const rawDecision = getExperimentValueById(
    state,
    AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.experiment,
  );

  const variant = matchDecisionByExperiment(
    AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.experiment,
    rawDecision,
  );
  const payload = getOnboardingExperiencePayload(state);
  const experienceFragmentKey = getOnboardingExperienceFragmentKey(variant, payload);

  return experienceFragmentKey
    ? dispatch(fetchExperienceFragment(experienceFragmentKey)(args))
    : undefined;
};

export default onboardingExperienceFragmentFetcher;
